// frontend/src/components/Auth/Registration/SchoolInfo.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../../../api/client';
import './SchoolInfo.css';

const SchoolInfo = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        school: '',
        city: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    const indianCities = [
        "Mumbai, Maharashtra", "Delhi", "Bangalore, Karnataka", "Hyderabad, Telangana",
        "Chennai, Tamil Nadu", "Kolkata, West Bengal", "Pune, Maharashtra",
        "Ahmedabad, Gujarat", "Surat, Gujarat", "Jaipur, Rajasthan", "Lucknow, Uttar Pradesh",
        "Kanpur, Uttar Pradesh", "Nagpur, Maharashtra", "Indore, Madhya Pradesh",
        "Bhopal, Madhya Pradesh", "Patna, Bihar", "Vadodara, Gujarat", "Agra, Uttar Pradesh"
    ];

    const handleCityChange = (e) => {
        const value = e.target.value;
        setFormData({ ...formData, city: value });

        if (value.length >= 2) {
            const filtered = indianCities.filter(city =>
                city.toLowerCase().includes(value.toLowerCase())
            );
            setSuggestions(filtered.slice(0, 6));
            setShowSuggestions(true);
        } else {
            setSuggestions([]);
            setShowSuggestions(false);
        }
    };

    const selectCity = (city) => {
        setFormData({ ...formData, city });
        setShowSuggestions(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!formData.school || formData.school.length < 3) {
            setError('🏫 School name must be at least 3 characters');
            triggerShake();
            return;
        }

        if (!formData.city) {
            setError('🌆 Please select your city');
            triggerShake();
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await authAPI.schoolInfo(formData);
            if (response.success) {
                // Success animation
                const card = document.querySelector('.school-card-gamified');
                if (card) {
                    card.classList.add('victory-glow');
                }
                setTimeout(() => {
                    navigate('/username');
                }, 1000);
            } else {
                setError(response.message || 'Failed to save information');
                triggerShake();
            }
        } catch (err) {
            setError('💀 Network error. Please try again.');
            triggerShake();
        } finally {
            setLoading(false);
        }
    };

    const triggerShake = () => {
        const card = document.querySelector('.school-card-gamified');
        if (card) {
            card.classList.add('game-shake');
            setTimeout(() => {
                card.classList.remove('game-shake');
            }, 400);
        }
    };

    return (
        <div className="school-gamified-world">
            {/* Simple floating particles */}
            <div className="particle-bg-school">
                {[...Array(20)].map((_, i) => (
                    <div key={i} className="particle-school" style={{
                        left: `${Math.random() * 100}%`,
                        animationDelay: `${Math.random() * 10}s`,
                        animationDuration: `${8 + Math.random() * 7}s`
                    }}></div>
                ))}
            </div>

            <div className="school-container-gamified">
                <div className="row justify-content-center">
                    <div className="col-lg-5 col-md-7">
                        <div className="school-card-gamified">
                            {/* Header */}
                            <div className="school-header-gamified">
                                <div className="game-badge-school">
                                    <i className="fas fa-dice-d20"></i>
                                    <span>QUEST BEGIN</span>
                                    <i className="fas fa-dice-d6"></i>
                                </div>
                                <div className="header-avatar">
                                    <span className="avatar-icon">🏫</span>
                                    <span className="sparkle">✨</span>
                                </div>
                                <h2>Welcome, Young Hero!</h2>
                                <p>Your adventure begins here</p>
                                <div className="xp-bar-school">
                                    <div className="xp-fill-school" style={{ width: '20%' }}></div>
                                    <span className="xp-text">Step 1 of 5</span>
                                </div>
                            </div>

                            {/* Body */}
                            <div className="school-body-gamified">
                                {error && (
                                    <div className="game-alert-school">
                                        <i className="fas fa-skull me-2"></i>
                                        {error}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    {/* School Name */}
                                    <div className="input-group-school">
                                        <label>
                                            <i className="fas fa-school"></i> 
                                            <span>SCHOOL NAME</span>
                                            <span className="required-badge">★ REQUIRED ★</span>
                                        </label>
                                        <div className="input-wrapper-school">
                                            <input
                                                type="text"
                                                value={formData.school}
                                                onChange={(e) => setFormData({ ...formData, school: e.target.value })}
                                                placeholder="Enter your school name"
                                                required
                                            />
                                            <div className="input-decoration-school">
                                                <i className="fas fa-scroll"></i>
                                            </div>
                                        </div>
                                        <div className="input-hint-school">
                                            <i className="fas fa-info-circle"></i> 
                                            Enter complete school name as per records
                                        </div>
                                    </div>

                                    {/* City with Suggestions */}
                                    <div className="input-group-school">
                                        <label>
                                            <i className="fas fa-map-marker-alt"></i> 
                                            <span>CITY</span>
                                            <span className="required-badge">⚡ LOCATION ⚡</span>
                                        </label>
                                        <div className="city-wrapper">
                                            <div className="input-wrapper-school">
                                                <input
                                                    type="text"
                                                    value={formData.city}
                                                    onChange={handleCityChange}
                                                    placeholder="Start typing your city"
                                                    autoComplete="off"
                                                    required
                                                />
                                                <div className="input-decoration-school">
                                                    <i className="fas fa-location-dot"></i>
                                                </div>
                                            </div>
                                            {showSuggestions && suggestions.length > 0 && (
                                                <div className="city-suggestions-gamified">
                                                    {suggestions.map((city, idx) => (
                                                        <div
                                                            key={idx}
                                                            className="city-suggestion-gamified"
                                                            onClick={() => selectCity(city)}
                                                        >
                                                            <i className="fas fa-crown"></i>
                                                            {city}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                        <div className="input-hint-school">
                                            <i className="fas fa-search"></i> 
                                            Type at least 2 characters to see suggestions
                                        </div>
                                    </div>

                                    {/* Progress Indicator */}
                                    <div className="quest-progress">
                                        <div className="quest-steps">
                                            <div className="step active">🏫</div>
                                            <div className="step">👤</div>
                                            <div className="step">🔐</div>
                                            <div className="step">📧</div>
                                            <div className="step">✅</div>
                                        </div>
                                        <div className="progress-bar-school">
                                            <div className="progress-fill-school" style={{ width: '20%' }}></div>
                                        </div>
                                        <p className="progress-text-school">Quest Progress: 20%</p>
                                    </div>

                                    {/* Continue Button */}
                                    <button type="submit" className="continue-btn-gamified" disabled={loading}>
                                        {loading ? (
                                            <>
                                                <span className="spinner-school"></span>
                                                <span>SUMMONING...</span>
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-feather-alt"></i>
                                                <span>Continue Journey →</span>
                                                <i className="fas fa-dragon"></i>
                                            </>
                                        )}
                                    </button>

                                    {/* Back Link */}
                                    <div className="back-link">
                                        <i className="fas fa-arrow-left"></i>
                                        <span>Already have an account?</span>
                                        <a href="/login" className="login-link-gamified">Login Here</a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SchoolInfo;